import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';


const Button = (props) => {

    const theme = useContext(ThemeContext);

    return ( 
        <button onClick={props.onClick} className={props.className} style={{borderColor:theme.currentTheme.borderColor, boxShadow: theme.currentTheme.boxShadow}}>{props.buttonTitle} </button>
     );
}
 
export default Button;